import { AppState } from '../types/store';
import {
  getFeedTypeSubnavigation,
  getThisUser,
  getCurrentPageType,
} from './page';
import { getIsCurrentStreamEmpty } from './stream';
import {
  getPagingMode,
  getIsMobile,
} from '@wix/da-shared-react/pkg/publicSession/selectors';

export function getShouldShowFooter(state: AppState): boolean {
  if (!getIsMobile(state) && getPagingMode(state) !== 'scroll') {
    return true;
  }

  // Show footer in case of no results
  return getIsCurrentStreamEmpty(state);
}

export function getShowNetworkBarInSiteHeader(state: AppState) {
  return ['search', 'tag', 'topic'].includes(
    state.currentPageData?.pageType ?? 'home'
  );
}

export function getSelectedNetworkBarItem(state: AppState) {
  if (state.currentPageData?.pageType === 'groups') {
    return state.currentPageData?.thisGroup;
  }

  return state.currentPageData?.pageType;
}

export function getShouldMarkSelectedNetworkBarItemAsRead(state: AppState) {
  // single user watch pages do not mark the networkbar itself read
  if (getCurrentPageType(state) === 'watch' && !!getThisUser(state)) {
    return false;
  }

  const nav = getFeedTypeSubnavigation(state);

  return nav?.options?.every(
    option => option.subnav === nav?.currentValue || !option.hasNewContent
  );
}
